import { render, staticRenderFns } from "./ReminderReportList.vue?vue&type=template&id=4b005390&"
import script from "./ReminderReportList.vue?vue&type=script&lang=js&"
export * from "./ReminderReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports